import { useNavigate } from 'react-router-dom';
import PrintRunsPage from '../../PrintRunsPage';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';

export default function PrintRunsContainer() {
  const navigate = useNavigate();
  const { currentUser, org } = useLegacyAppSession();

  return (
    <PrintRunsPage
      organizationId={org?.id ?? null}
      currentUser={currentUser}
      onAdd={() => navigate('/prints/new')}
      onEdit={(job) => navigate(`/prints/${job.id}/edit`, { state: { job } })}
    />
  );
}
